import React from "react";
import Chart from "react-apexcharts";

export default class AttentionCurve extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      series: this.returnSeriesData(),

      options: {
        theme: {
          palette: "palette3", 
        },
        tooltip: {
          y: this.props.graphData.data.current_graph_type_id === 1 ? {
            formatter: function(value) {
              return `${value}% still viewing`;
            },
          }: 
          this.props.graphData.data.current_graph_type_id === 2 ?
          {
            formatter: function(value) {
              return `${value}% still viewing`;
            },
          }:
          {
            formatter: function(value) {
              return `${value}% could still view`;
            },
          },



          x: this.props.graphData.data.current_graph_type_id === 1 ? {
            formatter: function(value) {
              return `${value} seconds dwell time`;
            },
          }: 
          this.props.graphData.data.current_graph_type_id === 2 ?
          {
            formatter: function(value) {
              return `${value} seconds page dwell time`;
            },
          }:
          {
            formatter: function(value) {
              return `${value} seconds viewable time`;
            },
          },
        },
        chart: {
          type: "area",
          zoom: {
            enabled: true,
          },
          toolbar:{
            tools:{
              download: false,
            }
          }
        },
        xaxis: {
          // tickAmount: 'dataPoints',
          type: "numeric",
          min:0,
          max: this.props.graphData.data.current_graph_type_id === 1 ? 5 : this.props.graphData.data.current_graph_type_id ===2 ? 60 : 15,
          // labels: {
          //   tickAmount: 10,
          //   min:0,
          //   forceNiceScale:true,
          // },

          labels: {
            // show:false,
            // formatter: function(value) {
            //   return `${Math.round(value)}`;
            // },
          },
          tooltip: {
            enabled: false,
          },
          title: {
            text: this.props.graphData.data.current_graph_type_id === 3 ? "Stim viewable time (s)" : this.props.graphData.data.current_graph_type_id === 2 ? "Page dwell time (s)" : "Stim dwell time (s)",
            style: {
              fontWeight: 500,
              fontFamily: "Roboto",
              color: "rgba(0, 0, 0, 0.54)",
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "straight",
        },

        yaxis: {
          labels: {
            formatter: function(value) {
              return `${value}%`;
            },
          },
          forceNiceScale:true,
          title: {
            text: this.props.graphData.data.current_graph_type_id === 3 ? "% of people with stim on screen" : this.props.graphData.data.current_graph_type_id === 2 ? "% of people viewing page" : "% of people viewing stim",
            style: {
              fontWeight: 500,
              fontFamily: "Roboto",
              color: "rgba(0, 0, 0, 0.54)",
            },
            offsetX: 8,
          },
        },
        legend: {
          horizontalAlign: "left",
        },
      },
    };
  }

  returnSeriesData() {
    let graphData = JSON.parse(
      JSON.stringify(this.props.graphData.data.data[0].graph_data)
    );
    let newGraphData = [
      {
        data: [],
        name: this.props.stimName,
      },
    ];
    for (let i = 0; i < graphData.length; i = i + 1) {
      graphData[i].y = Math.round(graphData[i].y / 100) / 10;
      graphData[i].x = Math.round(graphData[i].x);
      let yval = graphData[i].y;
      graphData[i].y = graphData[i].x;
      graphData[i].x = yval;
      newGraphData[0].data.push(graphData[i]);
    }
    return newGraphData;
  }

  render() {
    return (
      <div id="chart" style={{ width: "100%", height: 320, left: -8, top: -8 }}>
        <Chart
          options={this.state.options}
          series={this.state.series}
          type="area"
          height={325}
        />
      </div>
    );
  }
}
